<template>
  <v-container>
    <v-responsive class="mx-auto">
      <v-row v-if="details._id">
        <v-col cols="12">
          <registration-persons
            :registration-id="details._id"
            :enablePersonSearch="false"
            :readonly="readonly"
            v-bubble.error
            v-bubble.info
          />
        </v-col>
      </v-row>
    </v-responsive>
  </v-container>
</template>

<script>
import gql from 'graphql-tag'
import { mapState, mapGetters } from 'vuex'

import RegistrationPersons from '../components/RegistrationPersons.vue'
import { getters } from '../store'

export default {
  name: 'MemberPeopleView',

  components: { RegistrationPersons },

  data: () => ({
    details: {}
  }),

  computed: {
    ...mapState([
      'selectedMemberNumber'
    ]),
    ...mapGetters([
      getters.IS_ADMIN_FOR_REGISTRATION
    ]),
    readonly () {
      return !this[getters.IS_ADMIN_FOR_REGISTRATION]
    }
  },

  apollo: {
    details: {
      query: gql`query GetMemberDetails($memberNumber: String!) {
        details: memberDetails(memberNumber: $memberNumber) {
          _id
        }
      }`,
      variables () {
        return {
          memberNumber: this.selectedMemberNumber
        }
      },
      error (e) { this.$emit('error', e) },
      skip () {
        return !this.selectedMemberNumber
      }
    }
  }
}
</script>
